import { Brain, Network, GitBranch, Gauge, Waves, ScanSearch } from "lucide-react";
import ProductPageLayout from "@/components/ProductPageLayout";

export default function AIML() {
  return (
    <ProductPageLayout
      meta={{
        title: "AI & ML — Machine Learning for Market Data Analytics | Adviserz",
        description:
          "Machine learning models, pattern recognition, time-series analysis and feature engineering applied to market data analytics. AI outputs are informational and may contain errors.",
        canonical: "https://adviserz.in/ai-ml",
      }}
      overline="Platform · AI & Machine Learning"
      title="Machine learning applied to"
      accent="market data analytics."
      lede="Adviserz applies machine learning and statistical modelling to large volumes of market and news data. The objective is analytical: to measure, classify and summarise complex information. AI-generated outputs are informational, can be incorrect, and are never presented as investment advice."
      capabilities={[
        { icon: Brain, t: "Machine Learning Models", d: "Supervised and unsupervised models used for classification, clustering and measurement tasks across market datasets." },
        { icon: Waves, t: "Time-Series Analysis", d: "Statistical time-series methods applied to volatility, dispersion and regime characteristics of market data." },
        { icon: ScanSearch, t: "Pattern Recognition", d: "Detection of recurring statistical structures in historical data, always reported with base rates and sample sizes." },
        { icon: GitBranch, t: "Feature Engineering", d: "Transformation of raw market data into robust, well-documented quantitative features used across research workflows." },
        { icon: Network, t: "Model Infrastructure", d: "Versioned training pipelines, evaluation harnesses, drift monitoring and reproducible deployment of analytical models." },
        { icon: Gauge, t: "Model Evaluation", d: "Out-of-sample testing, stability analysis and explicit reporting of model limitations and failure modes." },
      ]}
      approach={[
        { t: "Data quality first", d: "Models are only as good as their inputs; data validation and cleaning precede any modelling work." },
        { t: "Explainability", d: "We prefer interpretable formulations and document what each model measures and what it ignores." },
        { t: "Human oversight", d: "Automated outputs are reviewed as part of platform development; AI is treated as an analytical aid, not an oracle." },
        { t: "Limitations disclosed", d: "Model outputs are shipped with their uncertainty, assumptions and known weaknesses stated alongside them." },
      ]}
      notWhatWeDo={[
        "AI does not tell users what to buy or sell",
        "No accuracy percentages or win-rate claims",
        "No automated advisory or robo-advisory service",
        "No guarantee that outputs are error-free or timely",
        "No claim that models predict future prices",
        "No substitute for independent research or professional advice",
      ]}
    />
  );
}
